import { render } from "./EditLoginInfo.vue?vue&type=template&id=48c15a5a&scoped=true"
import script from "./EditLoginInfo.vue?vue&type=script&lang=js"
export * from "./EditLoginInfo.vue?vue&type=script&lang=js"

import "./EditLoginInfo.vue?vue&type=style&index=0&id=48c15a5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c15a5a"]])

export default __exports__